import { http } from "@/core/http";
import type { DateRangeQuery } from "./overviewApi";

export interface LicenseOverviewPagination {
  page: number;
  page_size: number;
  total: number;
}

export interface ActiveLicenseOverviewItem {
  company: string | null;
  brand_grouping: string;
  product_model: string | null;
  pip: number | null;
  sum_qty: number | null;
  sum_pip_total: number | null;
}

export interface ExpiringSoonLicenseOverviewItem {
  company: string | null;
  brand_grouping: string;
  warranty_end_date: string;
  product_model: string | null;
  pip: number | null;
  sum_qty: number | null;
  sum_pip_total: number | null;
}

export interface ActiveLicenseOverviewResponse {
  total: number;
  items: ActiveLicenseOverviewItem[];
}

export interface ExpiringSoonLicenseOverviewResponse {
  pagination: LicenseOverviewPagination;
  items: ExpiringSoonLicenseOverviewItem[];
}

export interface LicenseOverviewQuery {
  company?: string;
  page?: number;
  page_size?: number;
  sort?: string;
}

export type LicenseTrendMode = "yearly" | "monthly" | "quarterly" | "date_range";

export interface LicenseTrendPoint {
  period_start: string;
  period_label: string;
  autodesk: number;
  bluebeam: number;
  sketchup: number;
  chaosgroup: number;
  adobe: number;
  others: number;
  total_active_licenses: number;
}

export interface LicenseTrendResponse {
  company_partner_id: number;
  company_name: string;
  mode: LicenseTrendMode;
  series: LicenseTrendPoint[];
}

export interface LicenseTrendQuery extends DateRangeQuery {
  mode: LicenseTrendMode;
}

export async function fetchActiveLicenseOverview(
  params: LicenseOverviewQuery
): Promise<ActiveLicenseOverviewResponse> {
  const res = await http.get<ActiveLicenseOverviewResponse>(
    "/odoo/license-overview/active",
    { params }
  );
  return res.data;
}

export async function fetchExpiringSoonLicenseOverview(
  params: LicenseOverviewQuery
): Promise<ExpiringSoonLicenseOverviewResponse> {
  const res = await http.get<ExpiringSoonLicenseOverviewResponse>(
    "/odoo/license-overview/expiring-soon",
    { params }
  );
  return res.data;
}

export async function fetchCustomerLicenseTrend(
  companyPartnerId: number,
  params: LicenseTrendQuery
): Promise<LicenseTrendResponse> {
  const res = await http.get<LicenseTrendResponse>(
    `/customers/company/${companyPartnerId}/license-overview/trend`,
    { params }
  );
  return res.data;
}
